import * as React from 'react';
import styled from 'styled-components';

import { WithBehaviorsProps } from '../behaviors';
import { CallToAction } from '../../../styling/styles';
import Spinner from '../components/Spinner';
import { button } from './Common';

const NextButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2em;
  max-width: 400px;
  width: 100%;
`;

const NextButton = button`
  ${CallToAction}
  padding: 16px 50px;
`;

const LoadingIconContainer = styled.div`
  width: 30px;
  right: 11px;
  position: absolute;
  top: 9px;
`;

const ButtonTextContainer = styled.span`
  position: relative;
  display: block;
  font-weight: 600;
`;

const PhoneCallLink = styled.a`
  display: hidden;
`;

const SubmitButton: React.SFC<WithBehaviorsProps & any> = (props) => {
  const linkRef = document.getElementById('phoneCallLink');
  return (
    <NextButtonContainer>
      <NextButton
        inverted={props.inverted}
        disabled={props.isLoading || props.disabled}
        type="submit"
        onClick={props.href && linkRef ? () => linkRef.click() : props.onClick}
        id={props.id}
        className={props.className}
      >
        {props.href ? <PhoneCallLink id="phoneCallLink" href={props.href} /> : null}
        <ButtonTextContainer>
          {props.isLoading && props.loadingText ? props.loadingText : props.text}
        </ButtonTextContainer>
        {props.isLoading && (
          <LoadingIconContainer>
            <Spinner />
          </LoadingIconContainer>
        )}
      </NextButton>
    </NextButtonContainer>
  );
};

export default SubmitButton;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/signup/components/SubmitButton.tsx